// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__6OD3Q","Logo":"Footer_Logo__J4HKK","Section":"Footer_Section__BCjNH","SectionColor":"Footer_SectionColor__FfVLV"};